// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ubHku","header__badge":"Header_header__badge__ZO-OU","header__avatar":"Header_header__avatar__WJ7eW"};